import Collaborators from "./Collaborators";

export default Collaborators;
